import { Typography, Grid, List, Paper, ListItem, ListItemIcon, ListItemText, Link, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AddCircleIcon from '@mui/icons-material/AddCircle';

const PaymentStructures = () => {
  return (
    <Grid container spacing={6} sx={{ mt: '4rem' }}>
      <Grid item xs={12} md={6}>
        <Paper
          elevation={20}
          sx={{
            padding: { xs: '2rem', md: '4rem' },
            borderRadius: 5,
            textAlign: 'center',
            mx: 'auto',
            height: '100%',
          }}>
          <Typography
            variant='h4'
            sx={{
              fontWeight: 'bold',
              textAlign: 'center',
              color: 'secondary.main',
              mb: '1rem',
            }}>
            THE COMMUNITY TIER
          </Typography>

          <Typography variant='h4' component='h2' sx={{ fontWeight: 'bold', mt: '1rem' }}>
            What will you get?
          </Typography>
          <Grid container spacing={0} direction='column' alignItems='center' justifyContent='center'>
            {' '}
            <List sx={{ maxWidth: { xs: '100%', sm: '100%' } }}>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText primary='Access to a private telegram community of >100 founders in Singapore' />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText primary='Membership card to get exclusive deals and perks with our partners' />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText primary='Case study feature of yourself and your business' />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText primary='Mentors who are powerhouses in their respective fields' />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText primary='Monthly teh peng chats, for 1-1 personal connections' />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText primary='Monthly private networking events, for an intimate group of 15-30 founders to engage casually' />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText primary='Yearly large networking events, for >50 founders to connect broadly' />
              </ListItem>
            </List>
          </Grid>

          <Link
            key={1}
            href='https://szuv34ek50v.typeform.com/to/w6ZwC5JX'
            sx={{
              textDecoration: 'none',
            }}>
            <Button variant='contained' sx={{ mt: '1rem' }}>
              JOIN TODAY
            </Button>
          </Link>
        </Paper>
      </Grid>
      <Grid item xs={12} md={6}>
        <Paper
          elevation={20}
          sx={{
            padding: { xs: '2rem', md: '4rem' },
            borderRadius: 5,
            textAlign: 'center',
            mx: 'auto',
            height: '100%',
          }}>
          <Typography
            variant='h4'
            sx={{
              fontWeight: 'bold',
              textAlign: 'center',
              color: 'secondary.main',
              mb: '1rem',
            }}>
            THE MASTERMIND TIER
          </Typography>
          <Typography variant='h4' component='h2' sx={{ fontWeight: 'bold', mt: '1rem' }}>
            What will you get?
          </Typography>
          <Grid container spacing={0} direction='column' alignItems='center' justifyContent='center'>
            <List sx={{ maxWidth: { xs: '100%', sm: '100%' } }}>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText primary='Everything in The Community Tier' />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <AddCircleIcon />
                </ListItemIcon>
                <ListItemText primary='Access to our flagship community offering - masterminds. With over 200 reviews and a 4.6/5 rating, our masterminds have been providing founders with a powerful business support group.' />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <AddCircleIcon />
                </ListItemIcon>
                <ListItemText primary='You will be matched into a hyper-curated mastermind of 8 founders which meets once every month, along with an executive facilitator, to discuss personal and business problems' />
              </ListItem>
            </List>
          </Grid>
          <Typography variant='p' component='p' sx={{ fontWeight: 'bold', mt: '1rem' }}>
            Minimum Criteria
          </Typography>
          <Typography variant='p' component='p' sx={{ mb: '1rem' }}>
            $10k cumulative revenue OR $100k in funding
          </Typography>
          <Link
            key={1}
            href='https://szuv34ek50v.typeform.com/to/GPAg2BTo'
            sx={{
              textDecoration: 'none',
            }}>
            <Button variant='contained' sx={{ mt: '1rem' }}>
              JOIN TODAY
            </Button>
          </Link>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default PaymentStructures;
